import { render, staticRenderFns } from "./payConfirm.vue?vue&type=template&id=10673c36&scoped=true"
import script from "./payConfirm.vue?vue&type=script&lang=js"
export * from "./payConfirm.vue?vue&type=script&lang=js"
import style0 from "./payConfirm.vue?vue&type=style&index=0&id=10673c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10673c36",
  null
  
)

export default component.exports